import { createContext, useContext } from 'react';

const LayoutSidebarContext = createContext(null);

export const LayoutSidebarProvider = LayoutSidebarContext.Provider;

export const useLayoutSidebar = () => {
    const ctx = useContext(LayoutSidebarContext);
    if (!ctx) {
        throw new Error('useLayoutSidebar must be used within <LayoutSidebarProvider>');
    }
    return ctx;
};
